import React from "react";
import NestedList from "@components/nested-list/nested-list.jsx";
import "./preconfig-view.scss";

const PreconfigView = ({ preconfigData, setPreconfigTree }) => {
  const handleSelect = (itemId, newValue = undefined) => {
    const updateTree = (items) => {
      let anySelected = false;

      const updatedItems = items.map((item) => {
        if (item.id === itemId) {
          const newSelected =
            newValue === undefined ? !item.selected : newValue;
          const updatedChildren = updateTreeWithState(
            item.children,
            newSelected
          );

          if (newSelected) anySelected = true;

          return { ...item, selected: newSelected, children: updatedChildren };
        }

        const [updatedChildren, childSelected] = updateTree(item.children);

        let newSelected = item.selected;
        if (childSelected) {
          newSelected = true; // bubble up
          anySelected = true;
        } else if (newSelected) {
          anySelected = true; // keep existing manual selection
        }

        return { ...item, selected: newSelected, children: updatedChildren };
      });

      return [updatedItems, anySelected];
    };

    setPreconfigTree((prev) => {
      const [items] = updateTree(prev.items);
      return { ...prev, items };
    });
  };

  const updateTreeWithState = (items, newState) =>
    items.map((item) => ({
      ...item,
      selected: newState,
      children: updateTreeWithState(item.children || [], newState),
    }));

  return (
    <div>
      {preconfigData.items.map((item) => (
        <div className="nested-list-container" key={item.id}>
          <NestedList key={item.id} item={item} handleSelect={handleSelect} />
        </div>
      ))}
    </div>
  );
};

export default PreconfigView;
